import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CalendarIcon, UserIcon, ArrowRightIcon } from 'lucide-react';
// Mock blog data
const blogPosts = [{
  id: 1,
  title: 'How to Create a Successful Digital Product',
  excerpt: 'Learn the key strategies for creating digital products that sell. From market research to pricing strategy, this guide covers everything you need to know.',
  image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
  date: 'May 15, 2023',
  author: 'Sarah Johnson',
  authorAvatar: 'https://randomuser.me/api/portraits/women/44.jpg',
  category: 'Marketing'
}, {
  id: 2,
  title: 'The Ultimate Guide to UI Design Principles',
  excerpt: 'Discover the fundamental principles of effective UI design. This comprehensive guide will help you create interfaces that are both beautiful and functional.',
  image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
  date: 'April 23, 2023',
  author: 'Michael Chen',
  authorAvatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  category: 'Design'
}, {
  id: 3,
  title: 'Pricing Strategies for Digital Products',
  excerpt: 'Pricing your digital products correctly is crucial for success. Learn different pricing models and how to choose the right one for your product.',
  image: 'https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
  date: 'March 10, 2023',
  author: 'Alex Thompson',
  authorAvatar: 'https://randomuser.me/api/portraits/men/42.jpg',
  category: 'Business'
}, {
  id: 4,
  title: '10 Essential Tools for Digital Creators',
  excerpt: 'Discover the must-have tools that every digital creator should use. From design software to productivity apps, these tools will streamline your workflow.',
  image: 'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
  date: 'February 28, 2023',
  author: 'Emily Rodriguez',
  authorAvatar: 'https://randomuser.me/api/portraits/women/28.jpg',
  category: 'Tools'
}, {
  id: 5,
  title: 'How to Market Your Digital Products Effectively',
  excerpt: 'Marketing is key to the success of your digital products. Learn proven strategies to reach your target audience and boost your sales.',
  image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
  date: 'January 15, 2023',
  author: 'David Wilson',
  authorAvatar: 'https://randomuser.me/api/portraits/men/22.jpg',
  category: 'Marketing'
}, {
  id: 6,
  title: 'The Future of Digital Products: Trends to Watch',
  excerpt: "Stay ahead of the curve by knowing what's coming next in digital products. The article explores emerging trends and what they mean for creators.",
  date: 'December 5, 2022',
  author: 'Sophia Lee',
  authorAvatar: 'https://randomuser.me/api/portraits/women/56.jpg',
  category: 'Trends'
}];
// Blog post card component
const BlogPostCard = ({
  post
}: {
  post: any;
}) => {
  return <div className="bg-white dark:bg-[#162825] rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300" data-id="element-4579">
      <div className="relative aspect-video overflow-hidden" data-id="element-4580">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-4581" />
        <div className="absolute top-3 left-3" data-id="element-4582">
          <span className="bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-full" data-id="element-4583">
            {post.category}
          </span>
        </div>
      </div>
      <div className="p-5" data-id="element-4584">
        <div className="flex items-center mb-3" data-id="element-4585">
          <div className="flex items-center mr-4" data-id="element-4586">
            <CalendarIcon className="h-4 w-4 text-gray-400 dark:text-[#7A8F8A] mr-1" data-id="element-4587" />
            <span className="text-xs text-gray-500 dark:text-[#7A8F8A]" data-id="element-4588">
              {post.date}
            </span>
          </div>
          <div className="flex items-center" data-id="element-4589">
            <div className="w-5 h-5 rounded-full overflow-hidden mr-1" data-id="element-4590">
              <img src={post.authorAvatar} alt={post.author} className="w-full h-full object-cover" data-id="element-4591" />
            </div>
            <span className="text-xs text-gray-500 dark:text-[#7A8F8A]" data-id="element-4592">
              {post.author}
            </span>
          </div>
        </div>
        <h3 className="text-xl font-semibold mb-2 text-gray-800 dark:text-[#F8FAF9] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-4593">
          {post.title}
        </h3>
        <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 line-clamp-3" data-id="element-4594">
          {post.excerpt}
        </p>
        <Link to={`/blog/${post.id}`} className="inline-flex items-center text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-4595">
          Read More
          <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-4596" />
        </Link>
      </div>
    </div>;
};
export const BlogPage = () => {
  const [scrolled, setScrolled] = useState(false);
  // Categories derived from blog posts
  const categories = ['All', ...Array.from(new Set(blogPosts.map(post => post.category)))];
  const [activeCategory, setActiveCategory] = useState('All');
  // Filter posts by category
  const filteredPosts = activeCategory === 'All' ? blogPosts : blogPosts.filter(post => post.category === activeCategory);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-4597">
      <Navbar scrolled={scrolled} data-id="element-4598" />
      <main className="pt-24 pb-20" data-id="element-4599">
        <div className="container mx-auto px-4 md:px-6" data-id="element-4600">
          <div className="max-w-6xl mx-auto" data-id="element-4601">
            {/* Header */}
            <div className="text-center mb-12" data-id="element-4602">
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4603">
                Blog
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD] max-w-3xl mx-auto" data-id="element-4604">
                Insights, tutorials, and news for digital creators and
                entrepreneurs
              </p>
            </div>
            {/* Categories */}
            <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-4605">
              {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${activeCategory === category ? 'bg-gradient-to-r from-[#0A3C52] to-[#2DB489] text-white' : 'bg-white dark:bg-[#162825] text-gray-600 dark:text-[#B0C1BD] hover:bg-gray-100 dark:hover:bg-[#1A3330]'}`} data-id="element-4606">
                  {category}
                </button>)}
            </div>
            {/* Featured Post */}
            {activeCategory === 'All' && <div className="mb-12" data-id="element-4607">
                <div className="bg-white dark:bg-[#162825] rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300" data-id="element-4608">
                  <div className="flex flex-col md:flex-row" data-id="element-4609">
                    <div className="md:w-1/2" data-id="element-4610">
                      <div className="relative h-full" data-id="element-4611">
                        <img src={blogPosts[0].image} alt={blogPosts[0].title} className="w-full h-full object-cover" data-id="element-4612" />
                        <div className="absolute top-3 left-3" data-id="element-4613">
                          <span className="bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-full" data-id="element-4614">
                            {blogPosts[0].category}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="md:w-1/2 p-6 md:p-8 flex flex-col justify-center" data-id="element-4615">
                      <div className="flex items-center mb-3" data-id="element-4616">
                        <div className="flex items-center mr-4" data-id="element-4617">
                          <CalendarIcon className="h-4 w-4 text-gray-400 dark:text-[#7A8F8A] mr-1" data-id="element-4618" />
                          <span className="text-xs text-gray-500 dark:text-[#7A8F8A]" data-id="element-4619">
                            {blogPosts[0].date}
                          </span>
                        </div>
                        <div className="flex items-center" data-id="element-4620">
                          <div className="w-5 h-5 rounded-full overflow-hidden mr-1" data-id="element-4621">
                            <img src={blogPosts[0].authorAvatar} alt={blogPosts[0].author} className="w-full h-full object-cover" data-id="element-4622" />
                          </div>
                          <span className="text-xs text-gray-500 dark:text-[#7A8F8A]" data-id="element-4623">
                            {blogPosts[0].author}
                          </span>
                        </div>
                      </div>
                      <h2 className="text-2xl font-bold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4624">
                        {blogPosts[0].title}
                      </h2>
                      <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-4625">
                        {blogPosts[0].excerpt}
                      </p>
                      <Link to={`/blog/${blogPosts[0].id}`} className="inline-flex items-center text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-4626">
                        Read Full Article
                        <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-4627" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Blog Posts Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4628">
              {filteredPosts.map(post => <BlogPostCard key={post.id} post={post} data-id="element-4629" />)}
            </div>
            {/* Newsletter Signup */}
            <div className="mt-16 bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white" data-id="element-4630">
              <div className="max-w-3xl mx-auto text-center" data-id="element-4631">
                <h2 className="text-2xl font-bold mb-3" data-id="element-4632">Stay Updated</h2>
                <p className="mb-6 opacity-90" data-id="element-4633">
                  Subscribe to our newsletter to get the latest articles,
                  tutorials, and updates delivered to your inbox.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto" data-id="element-4634">
                  <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-lg focus:outline-none text-gray-800" data-id="element-4635" />
                  <button className="bg-white text-[#0A3C52] px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-4636">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-4637" />
    </div>;
};